import Text from 'components/Text/Text';
import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import style from './CreateBtn.module.scss';

const CreateBtn: React.FC = () => {
	const hasAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.CLIENT_MANAGER,
		UserRoles.GROUP_MANAGER,
		UserRoles.TECHNICAL,
	]);

	return (
		<Link className={style.container} to={`/teasers${hasAccess ? '/create' : ''}`} data-test="CreateBtn">
			<Button
				className={style.button}
				theme="primaryBlue"
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#plus`} />
					</svg>
				}
				disabled={!hasAccess}>
				<Text translationNameSpace="listing" translationKey="addTeaserButton" asFragment={true} />
			</Button>
		</Link>
	);
};

export default CreateBtn;
